import React, { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";
import DataTable from "react-data-table-component";
import { useQuery } from "react-query";

/**
 * 
 * @param {state} props list of last buildings collection from backend 
 * @param {setState} props list sets when buildings are collected from backend to avoid multi collect for same data
 * @param {setSelectedBuilding} props object setter
 * @param {invoice} props string selected invoice type if present
 * @param {setStage} props string setter
 * @param {about} props string ticket about
 * @param {error} props string setter for api errors
 * 
 * @returns 
 */
const BuildingTicketStage = (props) => {

    const API = new PrivateApi();

    const [searchFieldFocus, setSearchFieldFocus] = useState(false);

    const [buildings, setBuildings] = useState([]);
    const [filteredBuildings, setFilteredBuildings] = useState([]);
    const [selectedBuilding, setSelectedBuilding] = useState(null);

    const [searchField, setSearchField] = useState("");
    const buildingsTableColumns = [
        { name: "Straße", selector: row => row.street, sortable: true, grow: 1.5, wrap: true },
        { name: "Objektbezeichnung", selector: row => row.x_objektbezeichnung, sortable: true, grow: 1.5, wrap: true },
        { name: "PLZ", selector: row => row.zip, sortable: true },
        { name: "Ort", selector: row => row.city, sortable: true, wrap: true }
    ];

    const paginationOptions = {
        rowsPerPageText: 'Zeilen pro Seite',
        rangeSeparatorText: 'von',
        selectAllRowsItemText: 'Alle'
    }


    const { data, error, isLoading } = useQuery(
        "TICKET_BUILDINGS",
        API.hw_Buildings,
        {
            staleTime: Infinity,
            onSuccess: (res) => {
                var data = res.data;
                if (data.buildings && data.buildings.length > 0) {
                    setBuildings(data.buildings);
                    setFilteredBuildings(data.buildings);
                }
            }
        }
    );

    const { data: cachedData} = useQuery('TICKET_BUILDINGS');

    useEffect(() => {
        if (cachedData) {
            setBuildings(cachedData.data.buildings);
            setFilteredBuildings(cachedData.data.buildings);
        }
    }, [cachedData])

    useEffect(() => {
        if (searchField.length !== "") {
            var filteredList = buildings.filter(b =>
                b.name.toLowerCase().includes(searchField.toLowerCase()) ||
                b.street.toLowerCase().includes(searchField.toLocaleLowerCase()) ||
                b.zip.toLowerCase().includes(searchField.toLocaleLowerCase()) ||
                b.city.toLowerCase().includes(searchField.toLocaleLowerCase()) ||
                b.x_objektbezeichnung.toLowerCase().includes(searchField.toLocaleLowerCase())
            );
            return setFilteredBuildings(filteredList);
        }
        setFilteredBuildings(buildings)
    }, [searchField])


    // select buildings table handler
    const selectTableBuildingsHandler = (row) => {
        if (selectedBuilding) {
            if (selectedBuilding === row) setSelectedBuilding(null);
            else setSelectedBuilding(row);
        } else {
            setSelectedBuilding(row);
        }
    }

    const conditionalRowStyles = [
        {
            when: row => selectedBuilding && selectedBuilding === row,
            style: {
                background: '#a2c13f',
                userSelect: "none",
            }
        }
    ]

    // next button handler
    const nextHandler = () => {
        props.setSelectedBuilding(selectedBuilding);
        if (selectedBuilding !== true && selectedBuilding !== false && selectedBuilding !== null) {
            if (props.about === "Energieliefervertrag") {
                props.setStage('Energieliefervertrag');
            } else {
                props.setStage("anlagen");
            }
        }
        else {
            props.setStage('body');
        }
    }

    if (isLoading) return (
        <Row className="text-center">
            <p>Ihre Gebäude werden gesammelt...</p>
            <Col xs="12">
                <Spinner className="text-energo" animation="grow" /> &nbsp;
                <Spinner className="text-energo" animation="grow" /> &nbsp;
                <Spinner className="text-energo" animation="grow" /> &nbsp;
            </Col>
        </Row>
    )

    // GUI
    return (
        <>
            <h5>Bitte wählen Sie ein Gebäude</h5>
            <Row className="mt-5">
                <Col xs="12">
                    <Form.Check
                        onChange={e => setSelectedBuilding(e.target.checked)}
                        value={undefined}
                        id="allBuildings"
                        type="checkbox"
                        label="Gebäude ist nicht relevant"
                    />
                </Col>
            </Row>

            <Row className="mt-4 align-items-center">
                <Col xs="12" md="12" xl={searchFieldFocus ? "12" : "8"}>
                    <FloatingLabel label="Suche nach Name, Objektbezeichnung, Straße, Ort, PLZ">
                        <Form.Control
                            onChange={e => setSearchField(e.target.value)}
                            value={searchField}
                            disabled={selectedBuilding === true}
                            placeholder="Suche nach Name, Objektbezeichnung, Straße, Ort, PLZ"
                            className="rounded-pill" />
                    </FloatingLabel>
                </Col>
            </Row>

            <Row className="mt-4">
                {filteredBuildings && filteredBuildings.length > 0 ?
                    <DataTable
                        data={filteredBuildings}
                        columns={buildingsTableColumns}
                        onRowClicked={row => selectTableBuildingsHandler(row)}
                        disabled={selectedBuilding === true}
                        conditionalRowStyles={conditionalRowStyles}
                        paginationComponentOptions={paginationOptions}
                        pagination dense pointerOnHover
                    />
                :null}
            </Row>
            <Row className="mt-5">
                <Col xs="12" className="text-end">
                    <Button onClick={() => props.invoice === "Energielieferant" ? props.setStage("Rechnung (ENERGO, Lieferantenrechnung)") : props.setStage("default")} variant="warning">Zurück</Button> &nbsp;
                    <Button
                        onClick={() => nextHandler()}
                        hidden={selectedBuilding === false || selectedBuilding === null}
                        className="btn-energo"
                    >Weiter
                    </Button>
                </Col>
            </Row>
        </>
    )
}

export default BuildingTicketStage;